module.exports = __webpack_public_path__ + "img/New PACI Flow - New.fe59b826.png";